<template>
  <v-container fluid class="pa-0">
    <v-app-bar flat color="red-darken-3">
      <v-app-bar-title>
        {{ $t("leko_employees.car_part_groups.label") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
      <v-spacer class="hidden-sm-and-down" />
    </v-app-bar>

    <v-tabs
      v-model="adminTab"
      color="red-darken-3"
      slider-color="grey-darken-4"
      bg-color="grey-lighten-4"
      class="border-b"
    >
      <v-tab value="grafiche_categories">
        {{ $t("leko_employees.car_part_groups.tab_grafiche_categories") }}
      </v-tab>
      <v-tab value="grafiche_titles">
        {{ $t("leko_employees.car_part_groups.tab_grafiche_titles") }}
      </v-tab>
      <v-tab value="cad_zones">
        {{ $t("leko_employees.car_part_groups.tab_cad_zones") }}
      </v-tab>
    </v-tabs>

    <v-window v-model="adminTab">
      <v-window-item value="grafiche_categories">
        <grafiche-categories-tab ref="graficheCategoriesTab" />
      </v-window-item>
      <v-window-item value="grafiche_titles">
        <grafiche-titles-tab ref="graficheTitlesTab" />
      </v-window-item>
      <v-window-item value="cad_zones">
        <v-row class="align-center justify-center mt-4 mb-8">
          <v-col cols="12" md="6" class="d-flex justify-center">
            <vehicle-view ref="vehicleView" @position="openDialog" />
          </v-col>
        </v-row>
      </v-window-item>
    </v-window>

    <selection-dialog ref="selectionDialog" />
  </v-container>
</template>

<script>
import VehicleView from "@/components/VehicleEntry/vehicleView.vue";
import SelectionDialog from "@/components/CarPartGroups/dialog.vue";
import GraficheCategoriesTab from "@/components/CarPartGroups/graficheCategoriesTab.vue";
import GraficheTitlesTab from "@/components/CarPartGroups/graficheTitlesTab.vue";
import { GRAFICHE_CATALOG_UPDATED_EVENT } from "@/services/graficheCatalogAdminStore.js";

export default {
  components: {
    "vehicle-view": VehicleView,
    "selection-dialog": SelectionDialog,
    "grafiche-categories-tab": GraficheCategoriesTab,
    "grafiche-titles-tab": GraficheTitlesTab,
  },
  data: () => ({
    adminTab: "grafiche_categories",
  }),
  mounted() {
    window.addEventListener(
      GRAFICHE_CATALOG_UPDATED_EVENT,
      this.syncGraficheTabs,
    );
  },
  beforeUnmount() {
    window.removeEventListener(
      GRAFICHE_CATALOG_UPDATED_EVENT,
      this.syncGraficheTabs,
    );
  },
  methods: {
    openDialog(position) {
      this.$refs.selectionDialog.open(position);
    },
    syncGraficheTabs() {
      this.$refs.graficheCategoriesTab?.reload?.();
      this.$refs.graficheTitlesTab?.reload?.();
    },
  },
};
</script>
